<adapt-dashboard-element name="People"
                         [url]="url$ | async">
    <adapt-team-membership class="d-block ms-1"
                           [team]="team"></adapt-team-membership>
</adapt-dashboard-element>
